import type { JSX } from 'react';

type ConfirmationToastProps = {
  message: string;
  closeIconUrl: string;
  onClose: () => void;
  bottomOffsetPx: number;
};

const TOAST_HEIGHT_PX = 56;

/**
 * Theme-driven confirmation toast UI.
 */
export function ConfirmationToast({
  message,
  closeIconUrl,
  onClose,
  bottomOffsetPx,
}: ConfirmationToastProps): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      className="confirmation-toast-responsive_vars fixed left-1/2 z-50 flex -translate-x-1/2 animate-confirmation-toast-enter items-center gap-2 rounded-confirmation-toast bg-confirmation_toast_background_color py-4 pl-4 pr-[6px]"
      style={{
        bottom: `${bottomOffsetPx}px`,
        height: `${TOAST_HEIGHT_PX}px`,
        fontFamily:
          'var(--confirmation_toast_font_family_resolved, Ubuntu-Medium)',
        fontWeight: 500,
        fontSize: 'var(--confirmation_toast_font_size_resolved, 14px)',
        lineHeight: 'var(--confirmation_toast_line_height_resolved, 20px)',
        letterSpacing:
          'var(--confirmation_toast_letter_spacing_resolved, -0.1px)',
        color: 'var(--confirmation_toast_message_font_color_resolved, #EFEFEF)',
      }}
    >
      <p className="min-w-0 flex-1 truncate">{message}</p>
      <button
        type="button"
        aria-label="Dismiss"
        className="flex h-10 w-10 shrink-0 items-center justify-center p-[10px]"
        onClick={onClose}
      >
        <img src={closeIconUrl} alt="" className="h-5 w-5" />
      </button>
    </div>
  );
}
